import { connect } from 'react-redux';

import { RootState } from '../../../../reducers';
import FileInput from '../../FileInput/FileInput';
import UploadedFilesStatus from '../../FileUpload/UploadedFilesStatus';
import MissingRequiredDocWarning from '../../MissingRequiredDocWarning/MissingRequiredDocWarning';
import { useDocPresentStatus } from '../../MissingRequiredDocWarning/MissingRequiredDocWarning.hook';
import { documentTypes } from '../../TradingHistory.helpers';
import thstyles from '../../TradingHistory.module.css';
import styles from '../OptionalStatement.module.css';

const mapStateToProps = (state: RootState) => {
    return {
        missingDocs: state?.tradingHistory?.missing
    };
};

const BWA_SuSa_Annual = ({
    quantifier,
    isOptional,
    missingDocs
}: {
    quantifier: number;
    isOptional: boolean;
    missingDocs: [];
}) => {
    const isDocMissing = useDocPresentStatus(
        missingDocs,
        'jaehrliche_bwa_susa_hochladen'
    );

    const subtitle =
        quantifier > 1
            ? `der letzten ${quantifier} Jahre`
            : `der letzten Jahres`;

    return (
        <>
            <div className={thstyles.headerSection}>
                <h3 className={thstyles.title}>BWAs und SuSas {subtitle}</h3>
                {isDocMissing && (
                    <MissingRequiredDocWarning dataTestId="jaehrliche_bwa_susa-warning-required" />
                )}
            </div>
            <div
                className={styles.CurrentManagementSection}
                data-testid="bwa_susa_annual-uploads">
                <div className={styles.descriptionContainer}>
                    <ul>
                        <li>
                            Alle BWAs sollten Firmenname, Umsatzerlöse,
                            Wareneinkauf, Kosten inkl. Abschreibungen,
                            Zinsaufwände & vorläufiges Ergebnis zeigen
                        </li>
                        <li>
                            Alle SuSas sollten EB-Wert, kumulierte Jahreswerte &
                            Saldo beinhalten und im korrekten Format eingereicht
                            werden
                        </li>
                    </ul>
                    <p>Beispiel SuSa Format Datev:</p>
                    <ul>
                        <li>Korrekt: alle bebuchten Konten oder Sachkonten</li>
                        <li>
                            Falsch: individueller Stapel, Konten ohne
                            Null-Salden
                        </li>
                    </ul>
                </div>
                <FileInput
                    documentType={documentTypes.jaehrliche_bwa_susa_hochladen}
                    buttonText="BWAs & SuSas hochladen"
                    isOptional={isOptional}
                />
            </div>
            <UploadedFilesStatus
                documentType={documentTypes.jaehrliche_bwa_susa_hochladen}
            />
        </>
    );
};

export default connect(mapStateToProps)(BWA_SuSa_Annual);
